import React from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';

export default class OVideoPlayerPopUp extends React.Component {
	constructor(props) {
		super(props);
		this.bindHandles();
	}

	componentDidMount() {
		document.addEventListener('mousedown', this.handleClickOutside);
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside);
	}

	bindHandles() {
		this.handleWrapperRef = this.handleWrapperRef.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
	}

	handleWrapperRef(node) {
		this.wrapperRef = node;
	}

	handleClickOutside(event) {
		if (this.props.onClose && this.wrapperRef && !this.wrapperRef.contains(event.target)) {
			this.props.onClose();
		}
	}

	render() {
		return (
			<section className="o-pop-up--video" ref={this.handleWrapperRef}>
				<ReactPlayer
					url={this.props.url}
					playing
				/>
			</section>
		);
	}
}

OVideoPlayerPopUp.propTypes = {
	url: PropTypes.string.isRequired,
	onClose: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/organisme/_organisme.video-player.js